<script>
  import { onMount, onDestroy } from 'svelte';

  export let isPast;
  export let debug = false;
  export let hiddenUntilScrolled = false;

  let waypoint;

  let observer;

  onMount(() => {
    observer = new IntersectionObserver(onIntersection);
    observer.observe(waypoint);
  });

  onDestroy(() => {
    if (observer) {
      observer.unobserve(waypoint);
    }
  });

  function onIntersection(entries) {
    isPast = entries[0].boundingClientRect.top < 0;
  }
</script>

<div class="Waypoint" class:hiddenUntilScrolled class:debug bind:this={waypoint}></div>

<style>
  .hiddenUntilScrolled {
    position: absolute;
    top: 100vh;
  }

  .debug {
    border-top: 1px dashed red;
  }
</style>
